<template>
  <div>
    <hshead title="店铺信息" bgcolor="#fff"></hshead>
    <div>
      <van-cell-group style="padding-bottom:20%;">
        <!-- <van-cell-group>
          <van-cell title="店铺logo">
            <img :src="StaticWebSite + '/' + tempData.logoUrl" alt />
          </van-cell>
        </van-cell-group>-->
        <van-field v-model="tempData.storesTypeName" label="店铺类型" input-align="right" disabled />
        <van-field
          v-model="tempData.storeFullName"
          label="店铺全称"
          input-align="right"
          placeholder="填写店铺全称"
        />
        <van-field
          v-model="tempData.storeName"
          label="店铺简称"
          input-align="right"
          placeholder="填写店铺简称"
        />
        <van-field
          v-model="tempData.contactName"
          label="联系人"
          input-align="right"
          placeholder="填写联系人"
        />
        <van-field v-model="tempData.mobile" label="手机号码" input-align="right" placeholder="填写手机号码" />
        <van-field v-model="tempData.phone" label="店铺联系电话" input-align="right" placeholder="填写电话" />
        <van-field
          v-model="tempData.areaName"
          label="所在城市"
          @click="choiceCity()"
          input-align="right"
          placeholder="选择城市"
          readonly
        />
        <van-field
          v-model="tempData.address"
          label="地址"
          input-align="right"
          placeholder="填写地址"
          type="textarea"
          rows="2"
          autosize
        />
        <van-field
          v-model="tempData.description"
          label="商户介绍"
          input-align="right"
          placeholder="填写商户介绍"
          type="textarea"
          rows="2"
          autosize
        />
        <van-field
          v-model="tempData.tags"
          label="宣传特殊标签"
          input-align="right"
          placeholder="多个标签用逗号分割"
        />
        <van-field
          v-model="tempData.keyword"
          label="查询关键字"
          input-align="right"
          placeholder="多个关键字用逗号分割"
        />
        <van-field v-model="tempData.slogan" label="服务口号" input-align="right" placeholder="填写服务口号" />
        <van-field
          v-model="tempData.foundingTime"
          label="店铺创立时间"
          placeholder="选择日期"
          @click="dateFieldClick('foundingTime', tempData.foundingTime)"
          input-align="right"
          readonly
        />
        <van-field
          v-model="tempData.businessHours"
          label="营业时间"
          input-align="right"
          placeholder="填写营业时间"
        />
        <van-field
          v-model="tempData.storeStatusName"
          label="店铺状态"
          input-align="right"
          readonly
          @click="storeStatusClick"
          placeholder="选择店铺状态"
        />
      </van-cell-group>
      <van-cell style="position:fixed;bottom:0;">
        <van-button type="info" size="large" class="my-btn" @click="handleUpdateBaseData">确定修改</van-button>
      </van-cell>
    </div>
    <van-popup v-model="showPopup" :close-on-click-overlay="false" position="bottom">
      <van-datetime-picker
        v-model="curSelectedDate"
        type="date"
        placeholder="日期"
        @confirm="datePickerConfirm"
        @cancel="datePickerCancel"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

    <van-popup v-model="showPopup2" :close-on-click-overlay="false" position="bottom">
      <van-picker
        :columns="areaColumns"
        @confirm="cityConfirm"
        @cancel="cityCancel"
        @change="cityChange"
        placeholder="==选择省份=="
        :showToolbar="true"
      />
    </van-popup>

    <van-popup v-model="showPopup3" :close-on-click-overlay="false" position="bottom">
      <van-picker
        :columns="storeStatusColumns"
        @confirm="storeStatusConfirm"
        @cancel="storeStatusCancel"
        placeholder="==选择=="
        :showToolbar="true"
        ref="storeStatusPicker"
        :default-index="curStoreStatusIdx"
      />
    </van-popup>
    <city
      :is-show.sync="city.isShow"
      :on-choose="city.onChoose"
      :city-data="city.cityData"
      :local-city="city.localCity"
      :close="close"
    ></city>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import {
  Toast,
  List,
  CellGroup,
  Cell,
  Field,
  Button,
  RadioGroup,
  Radio,
  Popup,
  DatetimePicker,
  Picker
} from "vant";
import { getStoreInfo, updateBaseData } from "@/api/m/store";
import { getCascaderData } from "@/api/m/shootCity";
import { idCardRegex } from "@/constant/regexExp";
import globalMixinBox from "@/assets/js/mixin.js";
import moment from "moment";
import $ from "jquery";
import Vue from "vue";

// 店铺类型；1: 普通店铺，2: 自营店铺，3: 个人店铺
const storesTypeOptions = [
  { key: "1", display_name: "普通店铺" },
  { key: "2", display_name: "自营店铺" },
  { key: "3", display_name: "个人店铺" }
];
// 店铺状态。0: 无意义，1: 正常营业，2: 暂停营业，3: 注销
const storeStatusOptions = [
  { key: "0", display_name: "未上架", tag_type: "info" },
  { key: "1", display_name: "正常营业", tag_type: "success" },
  { key: "2", display_name: "暂停营业", tag_type: "warning" },
  { key: "3", display_name: "注销", tag_type: "danger" }
];
Vue.use(DatetimePicker);
Vue.use(Popup);
export default {
  name: "storeInfo",
  mixins: [globalMixinBox.areaMixin],
  data() {
    return {
      StaticWebSite: window.StaticWebSite,
      tempData: {},
      curStoreStatusIdx: 0,
      //
      showPopup: false,
      showPopup2: false,
      showPopup3: false,
      timeShowSta: false,
      curSelectedDate: new Date(),
      curClickedField: "",
      //
      citys: {},
      areaColumns: null,
      cascaderData: {},
      //
      storeStatusColumns: storeStatusOptions.map(item => item.display_name),

      minDate: new Date("1950"),
      maxDate: new Date(),
      cityId1: ""
    };
  },
  created() {
    this.getStoreInfo();
  },
  methods: {
    getStoreInfo() {
      this.load(true, "加载中...");
      getStoreInfo()
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tempData = data;
            this.cityId1 = data.cityId;
            
            // var citys = this.city.cityData;
            // let self = this;
            // if(citys.length == 0){
            //   setTimeout(() => {
            //     console.log(this.city.cityData);
            //     self.tempData.areaName = this.returnCityName(self.cityId1);
            //   }, 1000);
            // }
            // else {
            //   this.tempData.areaName = this.returnCityName(data.cityId);
            // }
            
            this.tempData.areaName=response.data.cityName;
            this.tempData.storesTypeName = storesTypeOptions.filter(
              w => w.key == this.tempData.storesType
            )[0].display_name;
            this.tempData.storeStatusName = storeStatusOptions.filter(
              w => w.key == this.tempData.storeStatus
            )[0].display_name;
            this.curStoreStatusIdx = storeStatusOptions
              .map(item => item.key)
              .indexOf(`${this.tempData.storeStatus}`);
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(`${response}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    
    handleUpdateBaseData() {
      const { foundingTime, cityId, iDCard } = this.tempData;
      if (!foundingTime) {
        this.tips("请选择店铺创立时间");
        return;
      }
      if (!cityId) {
        this.tips("请选择城市");
        return;
      }
      const param = this.tempData;
      console.info("param", param);
      this.load(true, "加载中...");
      updateBaseData(param)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`操作成功`);
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    /************* 日期选择控件 *************/
    dateFieldClick(field, date) {
      this.showPopup = true;
      this.curClickedField = field;
      //console.info("date", date, moment(date));
      if (date)
        this.curSelectedDate = new Date(moment(date).format("YYYY-MM-DD"));
    },
    timeShowSta() {
      this.timeShowSta = true;
    },
    datePickerConfirm(val) {
      this.showPopup = false;
      console.info("datePickerConfirm", val, this.curClickedField);
      this.tempData[this.curClickedField] = moment(val).format("YYYY-MM-DD");
    },
    datePickerCancel() {
      this.showPopup = false;
    },
    /************* 省市选择 *************/
    cityClick() {
      this.showPopup2 = true;
    },
    cityCancel() {
      this.showPopup2 = false;
    },
    cityChange(picker, values) {
      picker.setColumnValues(1, this.citys[values[0]]);
    },
    cityConfirm(picker, values) {
      const provinceName = this.cascaderData[0].children[values[0]].label;
      const cityName = this.cascaderData[0].children[values[0]].children[
        values[1]
      ].label;

      this.tempData.cityId = this.cascaderData[0].children[values[0]].children[
        values[1]
      ].value;
      this.tempData.areaName = provinceName + " " + cityName;

      console.info("cityConfirm", picker, values, this.tempData.cityId);
      this.showPopup2 = false;
    },
    /************* 店铺状态 *************/
    storeStatusClick() {
      this.showPopup3 = true;
      console.info("this.$refs", this.$refs);
      //this.$refs.storeStatusPicker.setValues(this.tempData.storeStatus)
    },
    storeStatusCancel() {
      this.showPopup3 = false;
    },
    storeStatusConfirm(val, idx) {
      console.info("storeStatusConfirm", val, idx, this.tempData.storeStatus);
      this.tempData.storeStatusName = val;
      this.tempData.storeStatus = storeStatusOptions.filter(
        w => w.display_name == this.storeStatusColumns[idx]
      )[0].key;
      this.showPopup3 = false;
    }
  },
  components: {
    hshead,
    "van-list": List,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-field": Field,
    "van-button": Button,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-popup": Popup,
    "van-datetime-picker": DatetimePicker,
    "van-picker": Picker
  },
  watch: {
    city: {
      handler(val, oldVal) {
        if (val.localCity.cityName != "选择城市") {
          this.tempData.areaName = val.localCity.cityName;
          this.tempData.cityId = val.localCity.cityId;
        }      
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
// @import "~@/assets/less/common.less";
// @import "~@/assets/less/mixin.less";
.my-btn {
  border-radius: 1rem !important;
  background-color: #00b8f5 !important;
  font-size: 14px !important;
  border-color: transparent;
  height: 35px;
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// src/views/store/storeInfo.vue